import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        name: "advertising",
        path: "/",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/AdvertisingView.vue");
        }
    },
    {
        name: "welcome",
        path: "/welcome",
        meta: {
            timer: true
        },
        component: function() {
            return import("@/views/WelcomeView.vue");
        }
    },
    {
        name: "products",
        path: "/products",
        meta: {
            timer: true
        },
        component: function() {
            return import("@/views/ProductsView.vue");
        }
    },
    {
        name: "cart",
        path: "/cart",
        meta: {
            timer: true
        },
        component: function() {
            return import("@/views/CartView.vue");
        }
    },
    {
        name: "payment",
        path: "/payment",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/payment/PaymentView.vue");
        }
    },
    {
        name: "paymentCard",
        path: "/payment/card",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/payment/PaymentCardView.vue");
        }
    },
    {
        name: "paymentSBP",
        path: "/payment/sbp",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/payment/PaymentSbpView.vue");
        }
    },
    {
        name: "paymentError",
        path: "/payment/error",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/payment/PaymentErrorView.vue");
        }
    },
    {
        name: "settings",
        path: "/settings",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/SettingView.vue");
        }
    },
    {
        name: "service",
        path: "/service",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/ServiceView.vue");
        }
    },
    {
        name: "not-working",
        path: "/not-working",
        meta: {
            timer: false
        },
        component: function() {
            return import("@/views/NotWorkingView.vue");
        }
    },
]

if (import.meta.env.DEV) {
    routes.push({
        name: "payment-loading-preview",
        path: "/preview/payment-loading",
        meta: { timer: false },
        component: function() {
            return import("@/views/PaymentLoadingPreviewView.vue");
        },
    });
    routes.push({
        name: "order-error-preview",
        path: "/preview/order-error",
        meta: { timer: false },
        component: function() {
            return import("@/views/OrderErrorPreviewView.vue");
        }
    });
}

const router = createRouter({
	history: createWebHistory(),
	routes
})

export default router
